<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M6.24905 5C6.24905 2.92893 7.92799 1.25 9.99905 1.25C12.0701 1.25 13.7491 2.92893 13.7491 5C13.7491 7.07107 12.0701 8.75 9.99905 8.75C7.92799 8.75 6.24905 7.07107 6.24905 5Z" fill="#415A77"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.12509 16.7544C3.18954 13.013 6.24238 10 9.99905 10C13.7558 10 16.8087 13.0131 16.873 16.7547C16.8773 17.0028 16.7343 17.23 16.5088 17.3335C14.5263 18.2432 12.3212 18.75 9.99932 18.75C7.67727 18.75 5.47192 18.2431 3.48932 17.3332C3.26376 17.2297 3.12082 17.0026 3.12509 16.7544Z" fill="#415A77"/>
</svg>

</template>
